<template>
  <div id="homepage">
    <div class="leftpadding">
      <Cardinfo @loginOut="loginOut"></Cardinfo>
      <!-- 训练记录 -->
      <div class="tableContainer">
        <div class="titleText">
          <img src="../../assets/record.png" class="titlePic" />
          <span class="tit">演练记录</span>
          <router-link
            class="moreRecord"
            :to="{
              path: '/moreRecord',
            }"
            >更多></router-link>
        </div>
        <a-row style="padding: 1vw">
          <a-col>
            <div class="tablebox">
              <a-table
                :locale="{emptyText}"
                :columns="columns"
                :data-source="tableData"
                :pagination="false"
                rowKey="id"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="seedetails(record)">查看详情</a>
                </span>
              </a-table>
            </div>
          </a-col>
        </a-row>
        <!-- 演练配置 -->
        <div class="titleText">
          <img src="../../assets/peizhi.png" class="titlePic" />
          <span class="tit">演练配置</span>
        </div>
        <div class="configBox">
          <div class="itemContainer">
            <div class="configItem" @click="toschoolsetting">
              <img src="../../assets/danwei.png" class="configImg" />
              <div>受训单位</div>
              <div>配置</div>
            </div>
            <div class="configItem" @click="todepartmentsetting">
              <img src="../../assets/xuexi.png" class="configImg" />
              <div>受训单位</div>
              <div>部门配置</div>
            </div>
            <div class="configItem" @click="toYhaFiledControlList">
              <img src="../../assets/renyuan.png" class="configImg" />
              <div>受训人员</div>
              <div>信息配置</div>
            </div>
          </div>
          <div class="itemContainer">
            <div class="configItem" @click="toYhaDigitalCodeList">
                <img src="../../assets/erweima.png" class="configImg" />
                <div>受训人员</div>
                <div>二维码配置</div>
            </div>
            <div class="configItem" @click="toYhaFormworkList">
                <img src="../../assets/zhenshu.png" class="configImg" />
                <div>培训证书</div>
                <div>配置</div>
            </div>
            <div class="configItem" @click="toYhaPictureList">
                <img src="../../assets/picture.png" class="configImg" />
                <div>演练照片</div>
                <div>配置</div>
            </div>
          </div>
        </div>
        <!-- 演练照片 -->
        <Picture :picture='picture'></Picture>
        <!-- 演练照片 -->
        <div>
          <div class="titleText">
            <img src="../../assets/yanlianguanli.png" class="titlePic" />
            <span class="tit">演练管理</span>
          </div>
          <div class="manageContainer">
            <div
              class="manageItem left"
              @click.stop="
                jumpTo('/admin/frameworksettings/YhaPdfFrameworkList' + '?' + '上传演练报告')
              "
            >
              <div>
                <img src="../../assets/shangchuanicon.png" class="manageIcon" />
              </div>
              <div class="manageText">上传演练报告</div>
            </div>
            <div
              class="manageItem right"
              @click.stop="jumpTo('/admin/usermanage/YhaTeacherList'+ '?' + '单位账号配置')"
            >
              <div>
                <img src="../../assets/zhanghao.png" class="manageIcon" />
              </div>
              <div class="manageText">单位账号配置</div>
            </div>
          </div>
        </div>
        <!-- 互动管理 -->
        <div>
          <div class="titleText">
            <img src="../../assets/hudong.png" class="titlePic" />
            <span class="tit">互动管理</span>
          </div>
          <div class="interactContainer">
            <div
              class="interactItem left"
              @click.stop="jumpTo('/admin/clocks/clock/YhaClockList'+ '?' + '演练打卡管理')"
            >
              <div>
                <img src="../../assets/dakaicon.png" class="manageIcon" />
              </div>
              <div class="manageText">演练打卡管理</div>
            </div>
            <div
              class="interactItem center"
              @click.stop="jumpTo('/admin/notice/YhaNoticeList' + '?' +'最新消息管理')"
            >
              <div>
                <img src="../../assets/xiaoxiicon.png" class="manageIcon" />
              </div>
              <div class="manageText">最新消息管理</div>
            </div>
            <div
              class="interactItem right"
              @click.stop="jumpTo('/admin/YhaQa/YhaQaList' + '?' + '常见问题管理')"
            >
              <div>
                <img src="../../assets/wentiicon.png" class="manageIcon" />
              </div>
              <div class="manageText">常见问题管理</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 预约弹框 -->
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Search from "@/components/Search/Search";
import Cardtitle from "@/components/Cardtitle/Cardtitle";
import Cardinfo from "@/components/Cardinfo/Cardinfo";
import Solid from "@/components/Solid/Solid";
import moment from "moment";
import Axios from "@/Axios";
import infoAction from "@/utils";
import Picture from "@/components/Picture/Picture"
// import zhCN from '@/ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: "Homepage",
  components: {
    Header,
    Search,
    Cardtitle,
    Cardinfo,
    Solid,
    Picture,
  },
  data() {
    return {
      emptyText: '暂无数据',
      picture: [],
      locale: {
        // lang:{
        //   timeSelect:'选择时间',
        //   dateSelect:'选择日期',
        //   dateFormat: "M/D/YYYY",
        //   dateTimeFormat: "M/D/YYYY HH:mm:ss",
        //   now:'现在时间 ',
        //   ok:'确认'
        // }
        lang: {
          placeholder: "请选择日期",
          rangePlaceholder: ["Start date", "End date"],
          today: "今天",
          now: "现在时间",
          backToToday: "Back to today",
          ok: "Ok",
          clear: "Clear",
          month: "Month",
          year: "Year",
          timeSelect: "选择时间",
          dateSelect: "选择日期",
          monthSelect: "Choose a month",
          yearSelect: "Choose a year",
          decadeSelect: "Choose a decade",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
          monthBeforeYear: true,
          previousMonth: "Previous month (PageUp)",
          nextMonth: "Next month (PageDown)",
          previousYear: "Last year (Control + left)",
          nextYear: "Next year (Control + right)",
          previousDecade: "Last decade",
          nextDecade: "Next decade",
          previousCentury: "Last century",
          nextCentury: "Next century",
        },
        timePickerLocale: {
          placeholder: "Select time",
        },
      },
      traintime: "",
      input: "",
      url: {
        appoint: "/subscribe/yhaSubscribe/add",
        departlist: "/departments/yhaDepartments/list",
        university: "/university/yhaUniversity/queryById",
        trainlist: "/subscribe/yhaSubscribe/list",
        trainarrange: "/repcomposer/repComposer/report",
        alluniverrecord: "/repcomposer/repComposer/newReport",
        yhaPicture: "/picture/yhaPicture/list",
      },
      // 测试
      pagination: {
        pageNo: 1,
        pageSize: 5, // 默认每页显示数量
        // showSizeChanger: true, // 显示可改变每页数量
        // pageSizeOptions: ["5", "10", "20", "50", "100"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        // onShowSizeChange: this.onShowSizeChange, // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
      },
      departlist: [],
      centerDialogVisible: false,
      columns: [
        {
          dataIndex: "traintime",
          title: "训练时间",
          width: 90,
          key: "traintime",
          align: "center",
        },
        {
          dataIndex: "universityId_dictText",
          title: "用户名称",
          width: 90,
          key: "universityId_dictText",
          align: "center",
        },
        {
          title: "活动编码",
          width: 90,
          dataIndex: "activeCode",
          key: "activeCode",
          align: "center",
        },
        {
          title: "参与部门",
          width: 90,
          dataIndex: "traindepartment",
          key: "traindepartment",
          align: "center",
        },
        {
          title: "参与人数",
          width: 90,
          dataIndex: "peoplenum",
          key: "peoplenum",
          align: "center",
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 90,
        },
      ],
      tableData: [],
      tableheaderstyle: {
        backgroundColor: "#A6cefd",
      },
    };
  },
  created() {

  },
  mounted() {
    this.getPicture();
    this.getReport()
  },
  methods: {
     // 退出登录
    loginOut() {
      localStorage.clear()
      this.$router.push('/')
    },
    jumpTo(url) {
      window.location.href = url;
    },
    toschoolsetting() {
      window.location.href = "/admin/schoolAnddepartment/schoolsetting"+ '?' + '受训单位配置';
    },
    todepartmentsetting() {
      window.location.href = "/admin/schoolAnddepartment/departmentsetting"+ '?' + '受训人员部门配置';
    },
    toYhaFiledControlList() {
      window.location.href = "/admin/fieldcontroller/YhaFiledControlList"+ '?' + '受训人员信息配置';
    },
    toYhaDigitalCodeList() {
      window.location.href = "/admin/schoolAnddepartment/YhaDigitalCodeList"+ '?' + '受训人员二维码配置';
    },
    toYhaFormworkList() {
      window.location.href = "/admin/frameworksettings/YhaFormworkList"+ '?' + '培训证书配置';
    },
    toYhaPictureList() {
      window.location.href = "/admin/pic/YhaPictureList"+ '?' + '演练照片配置';
    },
    getReport() {
      Axios.get(this.url.alluniverrecord).then((res)=> {
        var records = res.data.result.records;
        var allarr = [];
        records.map((item, index) => {
            console.log(item.originalData);
            var arr;
            if (item.step == "1" && JSON.parse(item.originalData).length) {
              console.log(item.originalData);
              var originalData = JSON.parse(item.originalData)[0];
              var obj = {};
              obj.id = item.id;
              obj.departmentId = item.departmentId;
              obj.universityId = item.universityId;
              obj.departmentId_dictText = item.departmentId_dictText;
              obj.universityId_dictText = item.universityId_dictText;
              obj.peoplenum = originalData.参与人数;
              obj.traintime = originalData.训练日期;
              obj.traindepartment = originalData.参与院系 || originalData.参与部门;
              obj.activeCode = item.activeCode;
              allarr.push(obj);
            }
          });
          console.log(allarr);
          this.tableData = allarr.slice(0,3);
      })
    },
    getPicture() {
      Axios.get(this.url.yhaPicture).then((res) => {
        if (res.data.code === 200) {
          this.picture = res.data.result.records;
          this.picture.map((item) => {
            const picUrl = window.network['domianURL']+'/';
            item.pictureUrl = picUrl + item.picUrl;
            if (item.sort_dictText == '是') {
              item.isTop = true
            }else if (item.sort_dictText == '否') {
              item.isTop = false
            }
          });
        }
      });
    },
    toPublish() {},
    moment,
    handleviewdetails(index, data) {},
    // 查看受训人员成绩
    gostuscore() {
      this.$router.push("/searchresult");
    },
    // 获取学院列表
    // getdepartment(universityCode) {
    //   Axios.get(this.url.departlist, {
    //     params: {
    //       pageNo: 1,
    //       pageSize: 100,
    //       universityId: universityCode,
    //     },
    //   }).then((res) => {
    //     if (res.data.code == 200) {
    //       var result = res.data.result;
    //       this.departlist = result.records;
    //     }
    //   });
    // },
    // 取消预约框
    closeappoint() {
      this.centerDialogVisible = false;
    },
    // 训练安排查看详情
    seedetails(data) {
      debugger
      // console.log(data);
      this.$router.push({
        path: "/traindetails",
        query: {
          id: data.id,
          time: data.traintime,
          numofman: data.peoplenum,
          activeCode: data.activeCode,
          departmentId: data.departmentId,
          universityId: data.universityId,
          departmentId_dictText: data.departmentId_dictText,
          universityId_dictText: data.universityId_dictText,
        },
      });
    },
    // 部门改变
    handdepartChange() {},
    // 时间选择方法
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf("day");
    },
    disabledDateTime() {
      return {
        disabledHours: () => [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 12, 13, 19, 20, 21, 22, 23,
        ],
        // disabledHours: () => this.range(17,24).splice(17,9),
        disabledMinutes: () => this.range(),
        disabledSeconds: () => [],
      };
    },
    onPageChange(page) {
      console.log(page);
      // this.pagination.pageNo = page;
      this.pagination.current = page;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
.moreRecord {
  font-size: 15px;
  color: #999999;
  line-height: 25px;
  margin-left: auto;
  padding-right: 1vw;
  font-weight: normal;
}
}
@media screen and (min-width: 768px) {
.moreRecord {
  font-size: 15px;
  color: #999999;
  padding-right: 1vw;
  line-height: 30px;
  margin-left: auto;
  font-weight: normal;
}
}
@media screen and (max-width: 768px) {
.tablebox{
  overflow-x: auto;
}
}
@media screen and (max-width: 768px) {
.tablebox >>> .ant-table-thead {
  background: #E0E6F6;
}
.tablebox >>> .ant-table-thead > tr > th {
  padding: 16px 13px !important;
  background: #E0E6F6;
  font-size: 14px;
  color: #333333;
}
.tablebox >>> .ant-table-thead > tr > th> .ant-table-header-column {
  font-weight: bold;
}
.tablebox >>> .ant-table-tbody > tr > td {
  padding: 16px 3px !important;
}
}
@media screen and (min-width: 768px) {
.tablebox >>> .ant-table-thead {
  background: #E0E6F6;
}
.tablebox >>> .ant-table-thead > tr > th {
  padding: 37px 5px !important;
  background: #E0E6F6;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
.tablebox >>> .ant-table-tbody > tr > td {
  padding: 16px 5px !important;
  font-size: 19px;
}
}
@media screen and (max-width: 768px) {
  .btnBox {
    position: relative;
    top: -130px;
  }
}

.ant-modal-confirm-content {
  margin-left: 0px;
}
element.style {
  text-align: center;
}
.ant-table-thead > tr:first-child > th:first-child {
  border-top-left-radius: 4px;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 16px;
  overflow-wrap: break-word;
}

@media screen and (max-width: 768px) {
.titlePic {
  width: 22px;
  height: auto;
  margin-right: 10px;
  position: relative;
  top: -3px;
}
}
@media screen and (min-width: 768px) {
  .titlePic {
    width: 36px;
    height: auto;
    margin-right: 10px;
    position: relative;
    top: -3px;
}
}
.configBox {
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  padding: 1vw;
}
.configBox a {
  color: #333333;
}

.itemContainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
@media screen and (min-width: 768px) {
.configItem {
  width: 28%;
  height: 250px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background: #e9eef9;
  font-size: 23px;
  color: #333333;
  cursor: pointer;
  font-weight: bold;
}
.configImg {
  width: 50px;
  height: 50px;
  margin-top: 50px;
  margin-bottom: 5px;
}
}
@media screen and (max-width: 768px) {
  .configItem {
    width: 28%;
    height: 90px;
    box-sizing: border-box;
    margin-bottom: 10px;
    background: #e9eef9;
  }
  .configItem div {
    color: #333333;
    font-size: 14px;
    font-weight: bold;
  }
  .configImg {
    width: 25px;
    height: 25px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
.picBox {
  display: flex;
  justify-content: space-between;
}
.morePic {
  font-size: 15px;
  color: #999999;
  line-height: 60px;
  padding-right: 1vw;
}
.picContainer {
  padding: 1vw;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 768px) {
.picItem {
  width: 30%;
  height: 18vh;
  border: 1vw;
  margin-bottom: 15px;
  margin-right: 15px;
}
}
.reportContainer {
  width: 100%;
  padding: 1vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.reportItem {
  width: 30%;
  height: 240px;
  margin-bottom: 15px;
  background: url("../../assets/yanlianweb.png") no-repeat center center;
}
.reportDate {
  margin-top: 90px;
  color: #333333;
  font-size: 18px;
}
.manageContainer {
  width: 100%;
  padding: 1vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.manageItem {
  width: 45%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.manageContainer .left {
  background: url("../../assets/shangchuanweb.png") no-repeat center center;
}
.manageContainer .right {
  background: url("../../assets/zhanghaoweb.png") no-repeat center center;
}
.manageText {
  margin-top: 14px;
  color: #ffffff;
  font-size: 23px;
  font-weight: bold;
}
.interactContainer {
  width: 100%;
  padding: 1vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.interactItem {
  width: 30%;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.interactContainer .left {
  background: url("../../assets/dakaweb.png") no-repeat center center;
  background-size: contain;
}
.interactContainer .center {
  background: url("../../assets/xiaoxiweb.png") no-repeat center center;
  background-size: contain;
}
.interactContainer .right {
  background: url("../../assets/wentiweb.png") no-repeat center center;
  background-size: contain;
}
@media screen and (max-width: 768px) {
  .interactItem {
    width: 30%;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .interactContainer .left {
    background: url("../../assets/daka.png") no-repeat center center;
    background-size: contain;
  }
  .interactContainer .center {
    background: url("../../assets/xiaoxi.png") no-repeat center center;
    background-size: contain;
  }
  .interactContainer .right {
    background: url("../../assets/wenti.png") no-repeat center center;
    background-size: contain;
  }
}
@media screen and (max-width: 768px) {
  .manageItem {
    width: 45%;
    height: 100px;
  }
  .manageContainer .left {
    background: url("../../assets/shangchuan.png") no-repeat center center;
    background-size: contain;
  }
  .manageContainer .right {
    background: url("../../assets/zhanghaopeizhi.png") no-repeat center center;
    background-size: contain;
  }
  .manageIcon {
    width: 27px;
    height: 27px;
  }
  .manageText {
    margin-top: 7px;
    color: #ffffff;
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .picItem {
    width: 30%;
    height: 11vh;
    border: 1vw;
    margin-bottom: 4px;
    margin-right: 3px;
  }
}
@media screen and (max-width: 768px) {
  .reportItem {
    width: 30%;
    height: 130px;
    margin-bottom: 15px;
    background: url("../../assets/yanlianbaogao.png") no-repeat center center;
  }
  .reportDate {
    margin-top: 35px;
    color: #333333;
    font-size: 17px;
  }
}
@media screen and (min-width: 768px) {
  .leftpadding {
    box-sizing: border-box;
    width: 50%;
    margin: auto;
  }
}
.leftpadding {
  box-sizing: border-box;
  /* padding: 50px 3vw; */
}
.solid {
  height: 20px;
  /* background-color: #f0f2f5; */
}
.crumbs {
  box-sizing: border-box;
  padding: 30px 0 0 0;
  border-bottom: 2px solid #f0f2f5;
}
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tableContainer {
  position: relative;
  padding: 10px;
}
@media screen and (max-width: 768px) {
.titleText {
  margin-top: 3vh;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}
}
@media screen and (min-width: 768px) {
.titleText {
  margin-top: 94px;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 31px;
  display: flex;
  align-items: flex-end;
}
}
.tit {
  flex-shrink:0
}
.title {
  margin-top: 3vh;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}
.ant-table-column-title {
  overflow: inherit !important;
}
@media screen and (max-width: 768px) {
  .cardbox {
    border-bottom: 7px solid #f3f1f1;
    padding-bottom: 10px;
  }
}
.bookbox {
  /* height: 8vh; */
  display: flex;
  /* margin-top: 30px; */
  justify-content: center;
  align-items: center;
}
.bookbtn {
  box-shadow: 1px 4px 13px 0px rgba(25, 50, 100, 0.29);
}
.tablebox {
  box-shadow: 0px 4px 24px 0px rgba(45, 44, 44, 0.17);
  margin-top: 2vh;
  margin-bottom: 3vh;
}
.inputtext {
  text-align: right;
}
.inputbar {
  margin-bottom: 3vh;
}
.booksurebtn {
  width: 50%;
}
.icon {
  margin-right: 1vw;
}
/* .departselect::webkit-scrollbar { 
   display: none;
}
.depart::webkit-scrollbar { 
   display: none;
} */
/* @media screen and (max-width: 768px) {

} */
</style>



// WEBPACK FOOTER //
// src/views/Adminhomepage/Adminhomepage.vue